import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { ButtonSize, stateStyles } from './buttonStates';
import { ButtonColor } from './Button';

export const MotorButtonCircle: FunctionComponent<{
  icon: React.FunctionComponent<{ className?: string }>;
  size: ButtonSize;
  color: ButtonColor;
  darkMode?: boolean;
}> = ({ icon: Icon, size, color, darkMode }) => {
  return (
    <div
      className={classNames(
        'rounded-full flex items-center justify-center flex-none',
        { 'h-10 w-10': size !== 'large', 'h-12 w-12': size === 'large' },
        Object.values(stateStyles[color][darkMode ? 'darkMode' : 'lightMode'])
      )}
    >
      <Icon className={classNames(size === 'large' ? 'w-6 h-6' : 'w-5 h-5', 'w-10')} />
    </div>
  );
};
